import { getSerializer } from '@shared/serializers/serializer';

export const notifications = {
  type: 'notification',
  attributes: [
    'subject',
    'message',
    'createdAt',
    'updatedAt',
    'to',
  ]
};

export const NotificationsSerializer = getSerializer(notifications);
